export default __webpack_public_path__ + "static/hard-zen-10-min-demo-34d69cca5a4a6a3651c9c837ac5ade34.mp3";